<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-form class="px-8" v-on:submit.prevent="handleSubmit(save)">
            <v-row>
              <v-col cols="12" class="pt-0">
                <ValidationProvider
                  rules="required"
                  name="DegreeType"
                  v-slot="{ errors }"
                >
                  <v-radio-group
                    @change="getAdvicesByDegreeType"
                    class="mt-0"
                    :error-messages="errors"
                    v-model="form.degreeType"
                  >
                    <v-row class="radio-group">
                      <v-col cols="6" class="px-0 py-0">
                        <v-radio
                          class="label"
                          label="De Bac à Bac+3"
                          :value="3"
                        ></v-radio>
                      </v-col>
                      <v-col cols="6" class="px-0 py-0">
                        <v-radio
                          class="label"
                          label="De Bac+3 à Bac+6"
                          :value="1"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="mt--20">
                <div>
                  <p class="label d-inline-block">Advice</p>
                  <v-icon
                    v-if="form.degreeType"
                    @click="dialog = true"
                    class="float-right text-right"
                    v-text="'fas fa-plus-circle'"
                  ></v-icon>
                </div>
                <ValidationProvider
                  rules="required"
                  name="Advice"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="form.advice"
                    :disabled="!form.degreeType"
                    :items="advices"
                    item-value="id"
                    item-text="name"
                    outlined
                    max-width="100%"
                    style="max-width: 100%"
                    :error-messages="errors"
                  >
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="mt--20">
                <ValidationProvider
                  rules="required"
                  name="Name"
                  v-slot="{ errors }"
                >
                  <p class="label">Name</p>
                  <v-text-field
                    outlined
                    hide-details="auto"
                    v-model="form.name"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <p class="label">Contenu</p>
                <textarea
                  id="ckeditor"
                  placeholder="Tapez votre textes…"
                  v-model="form.content"
                  rows="10"
                  cols="80"
                ></textarea>
              </v-col>
              <v-col cols="12" class="py-3">
                <v-btn
                  class="x-2"
                  color="primary"
                  type="submit"
                  rounded
                  depressed
                  >Sauvegarder</v-btn
                >
                <v-btn
                  class="px-2 ml-3"
                  color="gray"
                  rounded
                  depressed
                  @click="cancel"
                  >Annuler</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="360px">
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form v-on:submit.prevent="handleSubmit(addAdvice)">
          <v-card>
            <v-card-title>
              <span>Add Advice</span>
            </v-card-title>
            <v-card-text>
              <ValidationProvider
                rules="required"
                name="Name"
                v-slot="{ errors }"
              >
                <p class="label">Name</p>
                <v-text-field
                  outlined
                  hide-details="auto"
                  v-model="advice.name"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
              <div class="text-center mt-5">
                <v-btn
                  class="body-1 px-7"
                  depressed
                  small
                  rounded
                  color="primary"
                  type="submit"
                  >Sauvegarder</v-btn
                >
                <v-btn
                  class="body-1 mr-0 px-7 black--text"
                  depressed
                  small
                  rounded
                  color="#E1E1E1"
                  @click="dialog = false"
                  >Annuler</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </ValidationObserver>
    </v-dialog>
  </v-container>
</template>
<script>
import adviceDetailService from "@/services/adviceDetail";
import adviceService from "@/services/advice";

import { mapState } from "vuex";
export default {
  name: "SpecialityForm",
  props: {},
  data: () => ({
    dialog: false,
    advices: [],
    advice: {
      name: "",
      degreeType: null
    }
  }),
  computed: {
    ...mapState({
      form: state => state.adviceDetail.adviceDetail
    })
  },
  async created() {
    if (this.form.degreeType) {
      await this.getAdvicesByDegreeType(false);
    }
  },
  mounted() {
    // eslint-disable-next-line
            CKEDITOR.replace('ckeditor');
  },
  methods: {
    async addAdvice() {
      this.advice.degreeType = this.form.degreeType;
      let res = await adviceService.create(this.advice);
      this.dialog = false;
      if (res) {
        this.advice = {
          name: "",
          degreeType: null
        };
        this.getAdvicesByDegreeType();
      }
    },
    async getAdvicesByDegreeType(reset = true) {
      let res = await adviceService.getAdvicesByDegreeType({
        degreeType: this.form.degreeType
      });
      if (res) {
        this.advices = res.data;
        if(reset) {
          this.form.advice = null;
        }
      }
    },
    cancel() {
      this.$store.dispatch("resetAdviceDetail");
      this.$router.push({
        name: "AdviceDetail"
      });
    },
    async save() {
      // eslint-disable-next-line
                this.form.content = CKEDITOR.instances.ckeditor.getData();
      if (this.form.id) {
        let res = await adviceDetailService.update(this.form);
        if (res) {
          this.$router.push({
            name: "AdviceDetail"
          });
        }
      } else {
        let res = await adviceDetailService.create(this.form);
        if (res) {
          this.$router.push({
            name: "AdviceDetail"
          });
        }
      }
    }
  }
};
</script>
<style lang="sass">

</style>
